export const formatNumber = (
  val: number | string | null | undefined,
  unit?: string
): string => {
  if (val == null || Number.isNaN(val)) return '\u2014';

  const hasDecimals = Math.abs((val as number) % 1) > 0;

  if (unit === '%') {
    const num = Number(val);
    const rounded = Math.round(num * 10) / 10;

    return hasDecimals ? rounded.toString() : num.toString();
  }

  const num = Number(val);

  if (hasDecimals) {
    const rounded = Math.round(num * 10) / 10;

    return rounded.toLocaleString('en-US');
  }

  return num.toLocaleString('en-US');
};

export const renderChangeValue = (
  val: number | string | null | undefined
): string => {
  if (val == null) return '\u2014';

  const num = Number(val);
  const hasDec = Math.abs(num % 1) > 0;
  const rounded = Math.round(num * 10) / 10;

  return hasDec ? rounded.toString() : num.toString();
};

export const pluralizeMetric = (type: string): string => {
  const lower = type.toLowerCase();

  switch (lower) {
    case 'inquiry':
    case 'inquiries':
      return 'Inquiries';
    case 'application':
    case 'applications':
      return 'Applications';
    case 'admit':
    case 'admits':
      return 'Admits';
    case 'net deposit':
    case 'net deposits':
      return 'Net Deposits';
    default:
      return type;
  }
};
